import { Facebook, Instagram, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { COMPANY, SERVICES } from "../data/site";
import { TikTokIcon } from "./icons/TikTokIcon";

export const Footer = () => {
  return (
    <footer className="bg-[var(--apex-primary)] relative overflow-hidden">
      <div className="absolute inset-0 grain opacity-[0.04]" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-16 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="inline-flex items-center gap-2 bg-white rounded-md px-4 py-3">
            <img src="/apex-logo.png" alt="Apex Home Pro Inc logo" className="h-20 w-auto" />
            <span className="font-display font-extrabold text-xl text-[var(--apex-primary)] mt-1">Inc.</span>
          </div>
          <p className="mt-4 text-slate-400 text-sm max-w-xs leading-relaxed">
            Trusted general contractor and remodeling company serving {COMPANY.area}. Licensed, insured, and built on craftsmanship.
          </p>
          <div className="flex gap-3 mt-5">
            <a href={COMPANY.facebook} target="_blank" rel="noreferrer" aria-label="Facebook" className="grid place-items-center h-9 w-9 rounded-sm bg-white/10 hover:bg-[var(--apex-accent)] text-white transition-colors"><Facebook size={17} /></a>
            <a href={COMPANY.instagram} target="_blank" rel="noreferrer" aria-label="Instagram" className="grid place-items-center h-9 w-9 rounded-sm bg-white/10 hover:bg-[var(--apex-accent)] text-white transition-colors"><Instagram size={17} /></a>
            <a href={COMPANY.tiktok} target="_blank" rel="noreferrer" aria-label="TikTok" className="grid place-items-center h-9 w-9 rounded-sm bg-white/10 hover:bg-[var(--apex-accent)] text-white transition-colors"><TikTokIcon size={17} /></a>
          </div>

          <div className="bz-bdg mt-6" data-testid="buildzoom-badge">
            <a target="_blank" rel="noreferrer" title="BuildZoom.com" href="https://www.buildzoom.com/contractor/apex-home-pro-inc-pa?ad_location=co_website">
              <img alt="BuildZoom.com" width="230" src="https://badges.buildzoom.com/2023/fon1.png" />
            </a>
            <a target="_blank" rel="noreferrer" href="https://www.buildzoom.com/wescosville-pa/general-contractors?ad_location=co_website&bg_ref=94842451">General Contractors in Wescosville</a>
            <img src="https://track.buildzoom.com//badge_load?track_id=Pw026d&entity=Contractor&event_type=impression&ad_type=contractor_badge" width="1" height="1" alt="" />
          </div>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-display font-bold text-white mb-4">Services</h4>
          <ul className="space-y-2">
            {SERVICES.map((s) => (
              <li key={s.id}><Link to={`/services/${s.id}`} className="text-slate-400 hover:text-white text-sm transition-colors">{s.title}</Link></li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="font-display font-bold text-white mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><a href="/#why" className="text-slate-400 hover:text-white transition-colors">Why Apex</a></li>
            <li><a href="/#work" className="text-slate-400 hover:text-white transition-colors">Our Work</a></li>
            <li><a href="/#reviews" className="text-slate-400 hover:text-white transition-colors">Reviews</a></li>
            <li><Link to="/remodeling-cost-guide" className="text-slate-400 hover:text-white transition-colors">Cost Guide</Link></li>
            <li><a href="/#contact" className="text-slate-400 hover:text-white transition-colors">Contact</a></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-display font-bold text-white mb-4">Contact</h4>
          <a href={`tel:${COMPANY.phoneRaw}`} className="flex items-center gap-2 text-slate-400 hover:text-white text-sm transition-colors"><Phone size={15} /> {COMPANY.phone}</a>
          <div className="flex items-start gap-2 text-slate-400 text-sm mt-3"><MapPin size={15} className="mt-0.5 shrink-0" /> {COMPANY.address}</div>
          <div className="text-slate-400 text-sm mt-3">{COMPANY.hours}</div>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-slate-500">
          <span>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</span>
          <span>General Contractor · Home Remodeling · Lehigh Valley, PA</span>
        </div>
      </div>
    </footer>
  );
};
